module.exports = __webpack_public_path__ + "img/organization-active.768e6862.svg";